export default __webpack_public_path__ + "static/media/cvk.b654d04f.jpg";